import React, { Component } from "react";
import  { SelectValue, LabeledValue } from "antd/lib/select";
import {Select,Spin,Modal,Row,Col,Card,Tag,Tree,Icon,Tabs,Button } from "antd";
import "./style.css";
import Organization from "./models/organization";
import AppService from "../service/app.service";
import PersonList from "./personList";
import PersonItem from "./models/personItem";
// 人员搜索
import UserSingleSelect from './user-single-select'

const { Option } = Select;
const { TreeNode } = Tree;
const { TabPane } = Tabs;
interface iProps {
  allowClear?: boolean;
  placeholder?: string;
  url?: string;
  value?: any[];
  tabs: any[];
  disabled?: boolean;
  onChange?: (value: PersonItem[] | Organization[]) => void;
  children?: React.ReactNode,
  userSelectUrl?: string
}
export default class GroupUserSelect extends Component<iProps> {
  private appService: AppService = new AppService();
  state = {
    loading: false,
    treeData: {},
    checkedIdsObj: {},
    tabs: [],
    visible: false,
    tabKey: "",
    expandedKeys: [],
    autoExpandParent: true,
    checkedOrganizationListObj: {},
    selectedKeysObj: {},
    selectedOrganizationObj: {},
    viewModeObj: {},
    list: [],
    searchValue: [],
    searchList: [], // 人员搜索框添加的
    propsList: [] // 通过外部传进来的
  };
  searchInputChange = async (value) => {
    let {searchList,list} = this.state;
    let isSelectedInThis = (searchList??[]).find(item => item.id === value.id)
    let isSelectedInOut = (list??[]).find(item => item.id === value.id)
    if (!isSelectedInThis && !isSelectedInOut) {
      searchList.push(value)
    }
    console.log(searchList)
    this.setState({searchList})
    // 已经选中的当前用户类型的列表
    // let valueSelectTypeSeleted = this.state.checkedOrganizationListObj[selectType]
    // valueSelectTypeSeleted.push(value)
    // await this.setState({
    //   checkedOrganizationListObj: {
    //     ...this.state.checkedOrganizationListObj,
    //     [value.selectType]: valueSelectTypeSeleted,
    //   }
    // })
    // 将当前用户的部门找出来 并将当前用户追加到部门的viewSubItems中
    // list: newProps.value,
      // checkedIdsObj,
      // checkedOrganizationListObj
    // console.log(this.state.list)
    // console.log(this.state.checkedIdsObj) 
    // console.log(this.state.checkedOrganizationListObj) 
    // let {list, checkedIdsObj, checkedOrganizationListObj} = this.state
    // let currentUser = list.find(item => 
    //   item.id === value.id
    // )
    // // 表示用户未被选中
    // if (!currentUser) {
    //   list.push(value)
    //   checkedIdsObj[selectType].push(value.id)
    // }
    // this.setState({list, checkedIdsObj})




    // let currentUserOrg = this.state.treeData[selectType].organizationList.find(item =>
    //   item.id === value.organizationId
    // )
    // console.log(currentUserOrg)
    // if (currentUserOrg && currentUserOrg.viewSubItems && currentUserOrg.viewSubItems.length) {
    //   let current =  currentUserOrg.viewSubItems.find(item => 
    //     item.id === value.id
    //   )
    //   if (!current) {
    //     currentUserOrg.viewSubItems.push(new PersonItem(value))
    //   }
    // } else {
    //   let currentCheckedOrganizationListObj = this.state.checkedOrganizationListObj[selectType]
    //   let current = (currentCheckedOrganizationListObj?? []).find(item => item.id === value.id)
    //   if (!current) {
    //     currentCheckedOrganizationListObj.push(value)
    //   }
    //   this.setState({
    //     checkedOrganizationListObj: {...this.state.checkedOrganizationListObj, [selectType]: currentCheckedOrganizationListObj}
    //   })
    //   // currentUserOrg.viewSubItems.push(new PersonItem(value))
    // }
    // this.setState({
    //   selectedOrganizationObj: {
    //     ...this.state.selectedOrganizationObj,
    //     [value.selectType]: currentUserOrg
    //   }
    // })

  }
  get title(): React.ReactNode {
    const { searchList, searchValue } = this.state;
    const {userSelectUrl} = this.props
    return (
      <>
        人员选择&#12288;
        <UserSingleSelect
          url={userSelectUrl || "/phoenix/usercenter3/api/v2/pc/selector/groupuser/search"}
          placeholder="搜索"
          userType={(this.props?.tabs??[]).map((item, index) => item.key).join(',')}
          onChange={this.searchInputChange}
          value={searchValue}>
          </UserSingleSelect>
      </>
    );
  }
  onExpand = (expandedKeys) => {
    this.setState({
      expandedKeys,
      autoExpandParent: false,
    });
  };
  renderTreeNodes = (organizationList: Organization[]) =>
    organizationList.map((organization: Organization) => {
      if (organization.subItems) {
        return (
          <TreeNode
            selectable={true}
            className="personItemTreeNode"
            title={
              <div className="personItem">
                {organization.name}{" "}
                <span className={organization.viewSubItems.length !==0 ? 'statistics selectedstatistics' : 'statistics'}>{`${organization.viewSubItems.length}/${organization.personNumber}`}</span>
              </div>
            }
            key={organization.id}
            dataRef={organization}
          >
            {this.renderTreeNodes(organization.subItems)}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          title={organization.name}
          key={organization.id}
          dataRef={organization}
        />
      );
    });
  onTabChange = async (key) => {
    await this.setState({ tabKey: key });
  };
  onSelect = (selectedKeys, e) => {
    console.log(e.node.props)
    this.setState({
      selectedKeysObj: {
        ...this.state.selectedKeysObj,
        [this.state.tabKey]: selectedKeys,
      },
      selectedOrganizationObj: {
        ...this.state.selectedOrganizationObj,
        [this.state.tabKey]: e.node.props.dataRef,
      },
      viewModeObj: {
        ...this.state.viewModeObj,
        [this.state.tabKey]: "list",
      },
    });
  };
  onCheckPersonItem = (personItemList) => {
    this.setState({
      viewModeObj: {
        ...this.state.viewModeObj,
        [this.state.tabKey]: "list",
      },
    });
  };
  onCheckOrganization = (checkedIds, e) => {
    console.log(checkedIds)
    console.log(this.state.checkedOrganizationListObj)
    let checkedOrganizationList = e.checkedNodes.map(
      (node) => node.props.dataRef
    );
    let removeIds = [];
    checkedOrganizationList.forEach((org) => {
      if (
        checkedOrganizationList.some((orgInner) => orgInner.id == org.parentId)
      ) {
        removeIds.push(org.id);
      }
    });
    if (removeIds.length>1) {
      for (let id of removeIds) {
        checkedOrganizationList.splice(
          checkedOrganizationList.findIndex((org) => org.id == id),
          1
        );
      }
    }
    this.setState({
      checkedIdsObj: {
        ...this.state.checkedIdsObj,
        [this.state.tabKey]: checkedIds,
      },
      checkedOrganizationListObj: {
        ...this.state.checkedOrganizationListObj,
        [this.state.tabKey]: checkedOrganizationList,
      },
    });
  };
  getGroupUserSelectTabTree = async () => {
    if(!this.state.treeData || JSON.stringify(this.state.treeData) === '{}') {
      for (let tab of this.props.tabs) {
        let {
          organizationNested,
          organizationList,
        } = await this.appService.getGroupUserSelectTabTree({
          selectType: tab.key,
          orgUrl: tab.orgUrl || ''
        });
        await this.setState({
          treeData: {
            ...this.state.treeData,
            [tab.key]: { organizationNested, organizationList },
          },
        });
        // this.setState({
        //   checkedIdsObj: {
        //     ...this.state.checkedIdsObj,
        //     [this.props.tabs[0].key]: ["2"],
        //   },
        // });
      }
    }
  };
  componentWillReceiveProps(newProps) {
   console.log(newProps);
    // checkedIdsObj[tab.key]
    let checkedIdsObj={};
    let checkedOrganizationListObj={};
    let propsList = []
    for (let tab of newProps.tabs) {
      let checkedIds = newProps.value.filter(
        (org) => ((org.selectType === tab.key))
      );
      console.log(checkedIds)
      // (async (checkedIds, tab) => {
      //   console.log(tab,checkedIds,this.state.checkedIdsObj)
      //   await this.setState({
      //     checkedIdsObj: {
      //       ...this.state.checkedIdsObj,
      //       [tab.key]: checkedIds.map((ids) => ids.id),
      //     },
      //   });
      // })(checkedIds, tab);
      checkedIdsObj[tab.key]=checkedIds.map((ids) => ids.id);
      checkedOrganizationListObj[tab.key]= checkedIds.filter(item => (!item.prop && (item.organizationType !== 'PERSON' || !(item.personNumber)))) // 不是通过外部传进来的User
      checkedIds.map(item => {item.prop && propsList.push(item)}) // 通过外部传进来的
      console.log(checkedIds)
      console.log(propsList)
    }
    this.setState({
      list: newProps.value,
      checkedIdsObj,
      checkedOrganizationListObj,
      propsList
    });
  }
  async componentDidMount() {
    await this.setState({
      tabKey: this.props.tabs[0].key,
    });
  }
  handleCancel = () => {
    this.closeList();
    this.setState({
      visible: false,
    });
  };
  closeList = () => {
    this.setState({
      viewModeObj: {
        ...this.state.viewModeObj,
        [this.state.tabKey]: "tree",
      },
    });
  };
  openModal = async () => {
    await this.setState({ visible: true });
    this.setState({ loading: true });
    this.getGroupUserSelectTabTree();
    this.setState({ loading: false });
  };
  removePersonItem = (
    key,
    organization: Organization,
    personItem: PersonItem | Organization
  ) => {
    organization.viewSubItems.splice(
      organization.viewSubItems.findIndex((item) => item.id === personItem.id),
      1
    );
    this.setState({
      viewModeObj: {
        ...this.state.viewModeObj,
        [this.state.tabKey]: "tree",
      },
    });
  };

  removeSearchUser = (
    user
  ) => {
    let {searchList} = this.state;
    searchList.splice(
      searchList.findIndex((item) => item.id === user.id),
      1
    );
    this.setState({
      viewModeObj: {
        ...this.state.viewModeObj,
        [this.state.tabKey]: "tree",
      },
      searchList
    });
  };
  removePropshUser = (
    user
  ) => {
    let {propsList} = this.state;
    propsList.splice(
      propsList.findIndex((item) => item.id === user.id),
      1
    );
    this.setState({
      viewModeObj: {
        ...this.state.viewModeObj,
        [this.state.tabKey]: "tree",
      },
      propsList
    });
  };
  deepGetCheckedIds = (organizationList: Organization[], alist?) => {
    let list = alist || [];
    for (let item of organizationList) {
      list.push(item.id);
      if (item.subItems && item.subItems.length) {
        list = this.deepGetCheckedIds(item.subItems, list);
      }
    }
    return list;
  };
  removeOrganizationItem = (key, organization: Organization) => {
    let { checkedOrganizationListObj = {} } = this.state;
    let checkedOrganizationList = checkedOrganizationListObj[key];
    checkedOrganizationList.splice(
      checkedOrganizationList.findIndex((item) => item.id === organization.id),
      1
    );
    let checkedIds = this.state.checkedIdsObj[key];
    for (let cid of this.deepGetCheckedIds([organization])) {
      checkedIds.splice(
        checkedIds.findIndex((id) => id === cid),
        1
      );
    }
    this.setState({
      viewModeObj: {
        ...this.state.viewModeObj,
        [key]: "tree",
      },
      checkedIdsObj: {
        ...this.state.checkedIdsObj,
        [key]: checkedIds,
      },
    });
  };
  onOk = () => {
    let { checkedOrganizationListObj = {}, treeData = {} } = this.state;
    let checkedOrganizationList = [];
    let checkedPersonItemList = [];
    for (let tab of this.props.tabs) {
      checkedOrganizationList = [
        ...checkedOrganizationList,
        ...(checkedOrganizationListObj[tab.key] ?? []).map(
          (organization: Organization) => organization
        ),
      ];
      let { organizationList } = treeData[tab.key] ?? [];
      for (let organization of organizationList) {
        checkedPersonItemList = [
          ...checkedPersonItemList,
          ...organization.viewSubItems,
        ];
      }
    }
    this.props.onChange &&
      this.props.onChange([
        ...checkedOrganizationList,
        ...checkedPersonItemList,
        ...this.state.searchList,
        ...this.state.propsList
      ]);
    this.setState({
      list: [
        ...checkedOrganizationList,
        ...checkedPersonItemList,
        ...this.state.searchList,
        ...this.state.propsList],
      visible: false,
    });
  };
  getTagStyle = (organization) => {
    if (organization.organizationType === "PERSON") {
      return 'userTag'
    } else {
      return 'departTag'
    }
  }
  render() {
    let {disabled = false, children = null} = this.props
    let {
      checkedOrganizationListObj = {},
      tabKey = "",
      checkedIdsObj,
    } = this.state;
    return (
      <>
        {/* <Input
          onClick={this.openModal}
          placeholder="请选择"
          readOnly
          suffix={<Icon type="usergroup-add" />}
        /> */}
        <div 
        onClick={disabled? () => (false) : this.openModal}  
        >
          {children ? 
            <div>{children}</div>:
            <div className={disabled ? 'group-person-select group-person-select-disabled' : 'group-person-select'}>
              {this.state.list.map((item) => (
                <Tag key={item.id}>{item.name}</Tag>
              ))}
              <div className="clear">
                <Icon style={{ fontSize: 18 }} type="usergroup-add" />
              </div>
            </div>
          }
        </div>
        <Modal
          className="GroupUserSelectModal"
          onCancel={this.handleCancel}
          width={772}
          footer={null}
          visible={this.state.visible}
          title={this.title}
          // title="人员选择"
          bodyStyle={{ padding: 0 }}
        >
          <Row>
            <Col span={12}>
              <div className="GroupUserSelectResult">
                {this.props.tabs.map((tab, index) =>
                  (checkedOrganizationListObj[tab.key] ?? []).map(
                    (organization: Organization) => (
                      <Tag
                      className={this.getTagStyle(organization)}
                        closable
                        onClose={(e) => {
                          e.preventDefault();
                          this.removeOrganizationItem(tab.key, organization);
                        }}
                        key={organization.id}
                      >
                        {organization.name}
                      </Tag>
                    )
                  )
                )}
                {this.props.tabs.map((tab) =>
                  (this.state.treeData[tab.key]?.organizationList ?? []).map(
                    (organization: Organization) =>
                      organization.viewSubItems.map((viewSubItem) => (
                        <Tag
                        className={this.getTagStyle(viewSubItem)}
                          onClose={(e) => {
                            e.preventDefault();
                            this.removePersonItem(
                              tab.key,
                              organization,
                              viewSubItem
                            );
                          }}
                          closable
                          key={viewSubItem.id}
                        >
                          {organization.name}
                          {viewSubItem.name}
                        </Tag>
                      ))
                  )
                )}
                {
                  (this.state.searchList ?? []).map(item => 
                    <Tag
                      className={this.getTagStyle(item)}
                        closable
                        onClose={(e) => {
                          e.preventDefault();
                          this.removeSearchUser(item)
                        }}
                        key={item.id}
                      >
                        {item.name}
                      </Tag>
                  )
                }
                {
                  (this.state.propsList ?? []).map(item => 
                    <Tag
                      className={this.getTagStyle(item)}
                        closable
                        onClose={(e) => {
                          e.preventDefault();
                          this.removePropshUser(item)
                        }}
                        key={item.id}
                      >
                        {item.name}
                      </Tag>
                  )
                }
              </div>
            </Col>
            <Col span={12}>
              <Card
              className="GroupUserSelect"
              bodyStyle={{ padding: 0 }}
              >
                <Spin
                  spinning={this.state.loading}
                  tip="加载中..."
                  size="large"
                >
                  <Tabs activeKey={tabKey} onChange={this.onTabChange}>
                    {this.props.tabs.map((tab, index) => (
                      <TabPane tab={tab.tab} key={tab.key} forceRender>
                        <div
                          style={{
                            height: 294,
                            position: "relative",
                            overflow: "auto",
                          }}
                        >
                          <Tree
                            // checkStrictly
                            checkable
                            style={{
                              display: `${
                                (this.state.viewModeObj[tab.key] ?? "tree") ===
                                "tree"
                                  ? "block"
                                  : "none"
                              }`,
                            }}
                            onCheck={this.onCheckOrganization}
                            onSelect={this.onSelect}
                            autoExpandParent={this.state.autoExpandParent}
                            checkedKeys={checkedIdsObj[tab.key] ?? []}
                            selectedKeys={
                              this.state.selectedKeysObj[tab.key] ?? []
                            }
                          >
                            {this.renderTreeNodes(
                              this.state.treeData[tab.key]
                                ?.organizationNested ?? []
                            )}
                          </Tree>
                          {(this.state.viewModeObj[tab.key] ?? "tree") ===
                            "list" && (
                            <PersonList
                              onCheck={this.onCheckPersonItem}
                              onCancel={this.closeList}
                              organization={ this.state.selectedOrganizationObj[tab.key] ?? {} }
                              personUrl={tab.personUrl}
                            ></PersonList>
                          )}
                        </div>
                      </TabPane>
                    ))}
                  </Tabs>
                </Spin>
              </Card>
            </Col>
          </Row>
          <div className="GroupUserSelectFooter">
            <div className="GroupUserSelectFooter_category">
              <span className="GroupUserSelectFooter_category_item GroupUserSelectFooter_category_depart">部门</span>
              <span className="GroupUserSelectFooter_category_item GroupUserSelectFooter_category_user">人员</span>
            </div>
            <div className="GroupUserSelectFooter_btn">
              <Button type="primary" onClick={this.onOk}>确定</Button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
